import { Injectable, Inject } from '@angular/core';
import { ApiCommonService } from 'cbc-shared-lib';
import { TimeApiService } from 'cbc-shared-lib';
import { Sgkc037aRequest, Sgkc037aResponse, SGKC037AService } from 'sg-api';
import { Observable, throwError } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';
import { FEATURES_LIB_CONFIG } from '../../../../../config/features-lib-config.token';
import { FeaturesLibConfig } from '../../../../../config/features-lib-config';

/**
 * 電気確定使用量再取込取消指示API使用サービス
 * @export
 * @class UsedSgkc037aService
 */
@Injectable({
    providedIn: 'root'
})
export class UsedSgkc037aService {
    /**
     * コンストラクタ
     * @param {SGKC037AService} sGKC037AService
     * @param {ApiCommonService} apiCommonService
     * @param {TimeApiService} timeApiService
     * @param {FeaturesLibConfig} featuresLibConfig
     * @memberof UsedSgkc037aService
     */
    constructor(private sGKC037AService: SGKC037AService,
        private apiCommonService: ApiCommonService,
        private timeApiService: TimeApiService,
        @Inject(FEATURES_LIB_CONFIG) private featuresLibConfig: FeaturesLibConfig) { }

    /**
     * 電気確定使用量再取込取消指示API呼び出し
     * @param {Sgkc037aRequest} request
     * @return {Observable<Sgkc037aResponse>}
     * @memberof UsedSgkc037aService
     */
    cancelElecUsageReimport(request: Sgkc037aRequest): Observable<Sgkc037aResponse> {

        // 年月日項目のフォーマット
        this.apiCommonService.convertElementInObject(request, Object.prototype.toString.call(new Date()), this.timeApiService.convertDateToString);

        return this.sGKC037AService.kC10WSGKC037APost(<Sgkc037aRequest>this.apiCommonService.setRequestCommon(request), 'response')
            .pipe(
                map(response => {
                    // エラーが設定されていないかチェックする
                    this.apiCommonService.checkError(response);
                    return response.body;
                }),
                timeout(Number(this.featuresLibConfig.httpTimeout)),
                catchError((err) => {
                    this.apiCommonService.dispErrorMessage(err, 'sgkc', 'SGKC037A');
                    return throwError(err.message);
                })
            );
    }

}
